/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_syl_haiku_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not a 5-7-5 haiku yet — aim for 5, 7, then 5 syllables.`)
};

const es_syl_haiku_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no es un haiku 5-7-5 — busca 5, 7 y luego 5 sílabas.`)
};

const de_syl_haiku_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch kein 5-7-5-Haiku — ziele auf 5, 7, dann 5 Silben.`)
};

const nl_syl_haiku_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen 5-7-5 haiku — streef naar 5, 7, dan 5 lettergrepen.`)
};

const fr_syl_haiku_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce n'est pas encore un haïku 5-7-5 — visez 5, 7, puis 5 syllabes.`)
};

const it_syl_haiku_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non è ancora un haiku 5-7-5 — punta a 5, 7, poi 5 sillabe.`)
};

const pt_br2_syl_haiku_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda não é um haiku 5-7-5 — busque 5, 7 e depois 5 sílabas.`)
};

const pt_syl_haiku_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda não é um haiku 5-7-5 — procure 5, 7 e depois 5 sílabas.`)
};

const ja_syl_haiku_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ5-7-5の俳句になっていません — 5音節、7音節、5音節を目指しましょう。`)
};

const zh_syl_haiku_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`还不是5-7-5俳句——请以5、7、5个音节为目标。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const syl_haiku_invalid = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.syl_haiku_invalid(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("syl_haiku_invalid", locale)
	if (locale === "en") return en_syl_haiku_invalid(inputs)
	if (locale === "es") return es_syl_haiku_invalid(inputs)
	if (locale === "de") return de_syl_haiku_invalid(inputs)
	if (locale === "nl") return nl_syl_haiku_invalid(inputs)
	if (locale === "fr") return fr_syl_haiku_invalid(inputs)
	if (locale === "it") return it_syl_haiku_invalid(inputs)
	if (locale === "pt-BR") return pt_br2_syl_haiku_invalid(inputs)
	if (locale === "pt") return pt_syl_haiku_invalid(inputs)
	if (locale === "ja") return ja_syl_haiku_invalid(inputs)
	return zh_syl_haiku_invalid(inputs)
};